<template>
  <div class="rounded-lg border border-cyan-400/25 bg-slate-950/35 p-3 space-y-3">
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
      <div :class="showScheduleSecondField ? 'sm:col-span-2' : 'sm:col-span-3'">
        <label class="block text-xs font-medium text-slate-300 mb-1">Recorrência</label>
        <select
          v-model="settings.schedule.mode"
          class="w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 focus:outline-none focus:ring-2 focus:ring-cyan-400/30 disabled:cursor-not-allowed disabled:bg-slate-950/80 disabled:text-slate-500 disabled:border-slate-600/50"
          :disabled="!scheduleEnabled"
        >
          <option value="interval_minutes">A cada X minutos</option>
          <option value="daily_at">Diário em horário fixo</option>
          <option value="weekly_at">Semanal (dias + horário)</option>
        </select>
      </div>
      <div v-if="showScheduleTimeInline">
        <label class="block text-xs font-medium text-slate-300 mb-1">Horário</label>
        <input
          v-model="settings.schedule.at_time"
          type="time"
          class="time-input w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 focus:outline-none focus:ring-2 focus:ring-cyan-400/30 disabled:cursor-not-allowed disabled:bg-slate-950/80 disabled:text-slate-500 disabled:border-slate-600/50"
          :disabled="!scheduleEnabled"
        />
      </div>
      <div v-else-if="showScheduleIntervalInline">
        <label class="block text-xs font-medium text-slate-300 mb-1">A cada (min)</label>
        <input
          v-model.number="settings.schedule.every_minutes"
          type="number"
          min="1"
          step="1"
          class="input-number-spin-sm w-full pl-3 pr-2 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 focus:outline-none focus:ring-2 focus:ring-cyan-400/30 disabled:cursor-not-allowed disabled:bg-slate-950/80 disabled:text-slate-500 disabled:border-slate-600/50"
          :disabled="!scheduleEnabled"
        />
      </div>
    </div>

    <div v-if="settings.schedule.mode === 'weekly_at'" class="space-y-2">
      <div>
        <label class="block text-xs font-medium text-slate-300 mb-1">Dias da semana</label>
        <div class="flex flex-wrap gap-2">
          <label
            v-for="d in weekDayOptions"
            :key="d.value"
            class="inline-flex items-center gap-2 px-2 py-1 rounded border border-slate-600/80 bg-slate-900/40 text-xs text-slate-300"
          >
            <input
              v-model="settings.schedule.weekdays"
              type="checkbox"
              :value="d.value"
              class="rounded border-slate-600 bg-slate-900 text-cyan-400 focus:ring-cyan-400/50"
              :disabled="!scheduleEnabled"
            />
            {{ d.label }}
          </label>
        </div>
      </div>
    </div>

    <div v-if="!hideOutputChannels" class="pt-2 border-t border-slate-600/60 space-y-3">
      <h4 class="text-sm font-medium text-slate-200">Canais de saída</h4>

      <div class="grid grid-cols-1 sm:grid-cols-[6rem_minmax(0,1fr)] gap-x-2 gap-y-2 sm:items-center">
        <label class="flex items-center gap-1.5 text-sm text-slate-300 min-w-0 py-1 sm:py-0">
          <input
            v-model="settings.outputs.email.enabled"
            type="checkbox"
            class="h-4 w-4 rounded border-slate-600 bg-slate-900 text-cyan-400 focus:ring-2 focus:ring-cyan-400/40 focus:ring-offset-0 focus:ring-offset-transparent shrink-0"
          />
          <span class="min-w-0 leading-tight">E-mail</span>
        </label>
        <input
          v-model="settings.outputs.email.to"
          type="text"
          placeholder="destino@empresa.com; financeiro@empresa.com"
          class="min-w-0 w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/30"
          :disabled="!settings.outputs.email.enabled"
        />

        <label class="flex items-center gap-1.5 text-sm text-slate-300 min-w-0 py-1 sm:py-0 sm:self-center">
          <input
            v-model="settings.outputs.whatsapp.enabled"
            type="checkbox"
            class="h-4 w-4 rounded border-slate-600 bg-slate-900 text-cyan-400 focus:ring-2 focus:ring-cyan-400/40 focus:ring-offset-0 focus:ring-offset-transparent shrink-0"
          />
          <span class="min-w-0 leading-tight">WhatsApp</span>
        </label>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 min-w-0 w-full sm:self-center">
          <div class="min-w-0">
            <select
              v-model="whatsappConnectorIdProxy"
              class="w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 focus:outline-none focus:ring-2 focus:ring-cyan-400/30 disabled:opacity-50"
              :class="whatsappConnectorIdProxy ? 'text-slate-100' : 'text-slate-400'"
              :disabled="!settings.outputs.whatsapp.enabled"
            >
              <option value="" class="text-slate-400">Selecione o conector…</option>
              <option v-for="opt in whatsappDeliveryConnectorOptions" :key="opt.id" :value="String(opt.id)" class="bg-slate-900">
                {{ opt.label }}
              </option>
            </select>
          </div>
          <div class="min-w-0">
            <input
              v-model="settings.outputs.whatsapp.to"
              type="text"
              placeholder="destino +5511999990000"
              class="w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/30"
              :disabled="!settings.outputs.whatsapp.enabled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentSchedules',
  props: {
    settings: { type: Object, required: true },
    /** Linha do agendamento ativa (checkbox «Ativar» no pai). */
    scheduleEnabled: { type: Boolean, default: true },
    weekDayOptions: { type: Array, default: () => [] },
    whatsappDeliveryConnectorOptions: { type: Array, default: () => [] },
    /** Analista de e-mail: só recorrência; e-mails permitidos ficam na configuração do agente. */
    hideOutputChannels: { type: Boolean, default: false }
  },
  computed: {
    whatsappConnectorIdProxy: {
      get() {
        const id = this.settings?.outputs?.whatsapp?.whatsapp_delivery_connector_id
        if (id == null || id === '') return ''
        const n = Number(id)
        return Number.isFinite(n) ? String(n) : ''
      },
      set(v) {
        if (!this.settings.outputs.whatsapp) {
          this.settings.outputs.whatsapp = { enabled: false, whatsapp_delivery_connector_id: null, to: '' }
        }
        const s = v === null || v === undefined ? '' : String(v)
        this.settings.outputs.whatsapp.whatsapp_delivery_connector_id =
          s === '' || Number.isNaN(Number(s)) ? null : Number(s)
      }
    },
    showScheduleTimeInline() {
      const m = this.settings?.schedule?.mode
      return m === 'daily_at' || m === 'weekly_at'
    },
    showScheduleIntervalInline() {
      const m = this.settings?.schedule?.mode
      return m === 'interval_minutes'
    },
    showScheduleSecondField() {
      return this.showScheduleTimeInline || this.showScheduleIntervalInline
    }
  },

  mounted() {
    this.ensureOutputShape()
  },

  methods: {
    ensureOutputShape() {
      const f = this.settings
      if (!f) return
      if (!f.outputs) f.outputs = {}
      if (!f.outputs.whatsapp) {
        f.outputs.whatsapp = {
          enabled: false,
          whatsapp_delivery_connector_id: null,
          to: ''
        }
      }
      if (!f.outputs.email) {
        f.outputs.email = { enabled: false, to: '' }
      }
      if (!f.schedule) {
        f.schedule = {
          enabled: false,
          mode: 'interval_minutes',
          every_minutes: 60,
          at_time: '08:00',
          weekdays: [1, 2, 3, 4, 5]
        }
      }
    }
  }
}
</script>

<style scoped>
/* type="time" no WebKit mantém texto claro com :disabled; alinhar à aparência do select */
.time-input:disabled {
  color: rgb(100 116 139);
  -webkit-text-fill-color: rgb(100 116 139);
}
.time-input:disabled::-webkit-calendar-picker-indicator {
  opacity: 0.45;
  filter: grayscale(0.85);
}

.input-number-spin-sm::-webkit-inner-spin-button {
  transform: scale(0.65);
  transform-origin: center right;
  opacity: 0.85;
  cursor: pointer;
}

.input-number-spin-sm::-webkit-outer-spin-button {
  opacity: 0.85;
}
</style>
